import axios from "axios";
import { apiClient } from "./client";

export interface CurrentUser {
    name: string;
    email: string;
    roles: string[];
}

export interface LoginRequest {
    email: string;
    password: string;
}

export async function login(request: LoginRequest): Promise<CurrentUser | null> {
    try {
        const response = await apiClient.post<CurrentUser>("/auth/login", request);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 401) {
            return null;
        }
        throw error;
    }
}

export async function logout(): Promise<void> {
    await apiClient.post("/auth/logout");
}

export async function getMe(): Promise<CurrentUser | null> {
    try {
        const response = await apiClient.get<CurrentUser>("/auth/me");
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 401) {
            return null;
        }
        throw error;
    }
}
